import { rest } from 'msw'
import { ChannelsPaymentsResponse } from 'types/channels'
import mockChannels from '../../../__mocks__/Channels/channels.json'
import mockChannelsPayments from '../../../__mocks__/Channels/channels_payments.json'
import { GetChannelsReq } from 'types/transaction/GetChannelsReq'

const getAllChannelsPayments = rest.get<ChannelsPaymentsResponse>(
  `${API_URL}/api/v2/channel/payment`,
  async (req, res, ctx) => {
    return res(ctx.json(mockChannelsPayments))
  }
)

const getChannels = rest.get<GetChannelsReq>(`${API_URL}/api/v2/channel`, async (req, res, ctx) => {
  return res(ctx.json(mockChannels))
})
export default [getAllChannelsPayments, getChannels]
